<div class="input-well">
  <div class="toolbar ql-toolbar ql-snow --flex" ref="wysiwygEditorToolbar">
    {{#any h2 h3 h4}}
    <span class="ql-formats">
      {{#if h2}}
      <button type="button" class="ql-header" value="2" title="Heading 2">H2</button>
      {{/if}}
      {{#if h3}}
      <button type="button" class="ql-header" value="3" title="Heading 3">H3</button>
      {{/if}}
      {{#if h4}}
      <button type="button" class="ql-header" value="4" title="Heading 4">H4</button>
      {{/if}}
    </span>
    {{/any}}
    <span class="ql-formats">
      {{#if bold}}
      <button type="button" class="ql-bold" title='Bold'>
        {{{ icon 'wysiwyg-bold' 'Bold' }}}
      </button>
      {{/if}}
      {{#if italic}}
      <button type="button" class="ql-italic" title='Italic'>
        {{{ icon 'wysiwyg-italic' 'Italic' }}}
      </button>
      {{/if}}
      {{#if underline}}
      <button type="button" class="ql-underline" title='Underline'>
        {{{ icon 'wysiwyg-underline' 'Underline' }}}
      </button>
      {{/if}}
      {{#if strikethrough}}
      <button type="button" class="ql-strike" title='Strikethrough'>
        {{{ icon 'wysiwyg-strike' 'Strikethrough' }}}
      </button>
      {{/if}}
      {{#if bulletedList}}
      <button type="button" class="ql-list" title='Bullet' value="bullet">
        {{{ icon 'wysiwyg-ul' 'Bulleted List' }}}
      </button>
      {{/if}}
      {{#if orderedList}}
      <button type="button" class="ql-list" title='List' value="ordered">
        {{{ icon 'wysiwyg-ol' 'Ordered List' }}}
      </button>
      {{/if}}
    </span>
    <span class="ql-formats">
      {{#if noBreakFormat}}
      <button type="button" class="ql-code" title='Prevent Line Breaks'>
        {{{ icon 'span' 'Prevent Line Breaks' }}}
      </button>
      {{/if}}
      {{#if link}}
      <button type="button" class="ql-link" title='Link'>
        {{{ icon 'wysiwyg-link' 'Link' }}}
      </button>
      {{/if}}
      {{#if phoneNumber}}
      <button type="button" class="ql-telephone" title='Telephone Number'>
        {{{ icon 'phone' 'Phone number' }}}
      </button>
      {{/if}}
      {{#if snippet}}
      <button type="button" class="ql-snippet" title='Snippet'>
        {{{ icon 'wysiwyg-snippet' 'Snippet' }}}
      </button>
      {{/if}}
    </span>
    {{#if html}}
    <span class="ql-formats wysiwyg-html-mode__tools">
      <button type="button" class="wysiwyg-html-mode__toggle" aria-pressed="false" title="{{htmlModeLabels.toggle}}" aria-label="{{htmlModeLabels.toggle}}">
        <sp-icon name="html" size="x-small"></sp-icon>
      </button>
    </span>
    {{/if}}
    {{#if sparkleAI}}
      <sp-spacer></sp-spacer>
      <div class="ql-formats --ai-app">
        <sp-ai-generator-quill-app ref="ql-sparkle-ai"></sp-ai-generator-quill-app>
      </div>
    {{/if}}
    {{#if modalView}}
    <span class="ql-formats modal-view">
      <button type="button" title='Expand'>
        {{{ icon 'expand' 'Expand Editor' }}}
      </button>
    </span>
    {{/if}}
  </div>
  <div class="editor ql-container ql-snow" ref="wysiwygEditor"></div>
  {{#if html}}
  <textarea class="wysiwyg-html-mode__source" aria-label="{{htmlModeLabels.sourceLabel}}" spellcheck="false" autocomplete="off" hidden></textarea>
  <p class="wysiwyg-html-mode__notice --unsupported" role="status" hidden>{{htmlModeLabels.unsupportedNotice}}</p>
  <div class="wysiwyg-html-mode__notice --lossy" role="alert" hidden>
    <p>{{htmlModeLabels.lossyWarning}}</p>
    <sp-button class="wysiwyg-html-mode__switch-anyway" size="small" variant="outlined" color="danger">{{htmlModeLabels.switchAnyway}}</sp-button>
    <sp-button class="wysiwyg-html-mode__keep-editing" size="small" variant="text">{{htmlModeLabels.keepEditing}}</sp-button>
  </div>
  {{/if}}
</div>
